<div class="video-component__media" (click)="startVideo()">
  <video #videoPlayer [src]="video.source" controls="" preload="none" class="video-content lazy"
    [poster]="overlaySource" [autoplay]="autoplay ? 'autoplay' : null">
  </video>
  <div *ngIf="!autoplay && !isVideoPlaying" class="video-component__overlay" (click)="startVideo()">
    <i class="video-component__overlay-icon far fa-play-circle"></i>
  </div>
</div>